document.getElementById('freight-calculator-form').addEventListener('submit', async function (e) {
    e.preventDefault();

    const cepInput = document.getElementById('freight-calculator-cep');
    const cep = cepInput.value.replace(/\D/g, '');

    const loadingDiv = document.getElementById('freight-calculator-loading');
    const resultsDiv = document.getElementById('freight-calculator-results');

    // Validação do CEP
    if (cep.length !== 8) {
        loadingDiv.style.display = 'none';
        resultsDiv.innerHTML = `
            <div class="milie-frete__error">
                Digite um CEP válido com 8 dígitos.
            </div>
        `;
        resultsDiv.style.display = 'block';
        return; // IMPORTANTE: impede a execução do fetch
    }

    // Obtendo o valor da nota fiscal e limpando a string
    let priceText = (
        document.querySelector('.price-item--sale') ||
        document.querySelector('.price-item--regular')
    ).textContent.trim();

    priceText = priceText.replace(/[^\d,.-]/g, '');
    priceText = priceText.replace(',', '.');

    const shipmentInvoiceValue = parseFloat(priceText);

    // Mostrar mensagem de carregamento
    loadingDiv.style.display = 'block';
    resultsDiv.style.display = 'none';

    try {
        const response = await fetch('https://freight-calculator-andres-projects-31b8c63f.vercel.app/api/get-freight', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                SellerCEP: '25645005',
                RecipientCEP: cep,
                ShipmentInvoiceValue: shipmentInvoiceValue,
                ShippingItemArray: [
                    {
                        Height: 1,
                        Length: 1,
                        Quantity: 1,
                        Weight: 0.01,
                        Width: 1,
                        SKU: 'IDW_54626',
                        Category: 'Running'
                    }
                ],
                RecipientCountry: 'BR'
            })
        });

        const data = await response.json();

        loadingDiv.style.display = 'none';

        if (data.ShippingSevicesArray) {
            // Mantém a ordem devolvida pela API
            const services = data.ShippingSevicesArray;

            // Menor prazo -> recebe o selo "Mais rápido"
            const fastest = Math.min(...services.map(s => parseInt(s.DeliveryTime, 10)));

            const infoIcon = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="9"/>
                    <path d="M12 11.2v5.3M12 7.6v.4"/>
                </svg>
            `;

            const rows = services.map(service => {
                const shippingPrice = parseFloat(service.ShippingPrice);
                const isFree = shippingPrice === 0;
                const priceText = isFree
                    ? 'Grátis'
                    : `R$ ${shippingPrice.toFixed(2).replace('.', ',')}`;

                const days = parseInt(service.DeliveryTime, 10);
                const dayLabel = days === 1 ? 'dia útil' : 'dias úteis';

                const badge = days === fastest
                    ? '<span class="milie-frete__badge">Mais rápido</span>'
                    : '';

                return `
                    <div class="milie-frete__row">
                        <span class="milie-frete__svc">
                            <span class="milie-frete__name">${service.ServiceDescription}</span>
                            ${badge}
                        </span>
                        <span class="milie-frete__eta">${service.DeliveryTime} ${dayLabel}</span>
                        <span class="milie-frete__price${isFree ? ' milie-frete__price--free' : ''}">${priceText}</span>
                    </div>
                `;
            }).join('');

            resultsDiv.innerHTML = rows + `
                <div class="milie-frete__note">
                    ${infoIcon}
                    <span>Esse prazo já inclui o nosso tempo de produção.</span>
                </div>
            `;

            resultsDiv.style.display = 'block';

        } else {
            throw new Error('No shipping services available');
        }

    } catch (error) {
        loadingDiv.style.display = 'none';
        alert('Erro ao obter cotações de frete. Por favor, tente novamente.');
    }
});